// export const APP_NAME = "Multy - Med"
export const APP_NAME = "EnlivCred"